<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Material</h4>
            </div>
            <div class="card-body">
                <h3 style="text-align: center">Materiales disponibles de cada almacén</h3>
                <p style="opacity: 0.3">
                    En este apartado, tendrás la posibilidad de revisar la cantidad exacta con el material que cuentas para cada almacén.
                    La gráfica muestra las cantidades disponibles para cada almacén y en la tabla puedes hacer una búsqueda, filtrando
                    por los campos mostrados cualquier criterio que desees.
                </p>
                <div class="col-sm-6">
                    <label class="float float-left col-md-6">Selecciona la sucursal</label>
                    <div class="col-md-8">
                        <select class="form-control" style="text-align: center; width: 270px" name="conceptId" [(ngModel)]="sucursal" (ngModelChange)="sucursalMetodo()">
                            <option value="2">Vallejo</option>
                            <option value="4">Aguascalientes</option>
                            <option value="5">Guadalajara</option>
                            <option value="6">Puerto Vallarta</option>
                            <option value="7">La Paz</option>
                            <option value="8">Querétaro</option>
                            <option value="9">Cancún</option>
                            <option value="10">Los Cabos</option>
                            <option value="11">Tijuana</option>
                            <option value="12">Coatzacoalcos</option>
                            <option value="13">Mazatlán</option>
                            <option value="14">Tlaquepaque</option>
                            <option value="15">Cuernavaca</option>
                            <option value="16">Monterrey</option>
                            <option value="17">Toluca</option>
                            <option value="18">Culiacán</option>
                            <option value="19">Puebla</option>
                            <option value="20">Chiapas</option>
                            <option value="22">Mérida</option>
                        </select>
                    </div>
                </div>
                <!--
                    <div class="float float-right">
                        <button class="btn btn-success" (click)="actualizarInventarios()">Actualizar inventarios</button>
                    </div>
                -->
                <!-- ============================= -->
                <!-- ========== GRAFICA ========== -->
                <!-- ============================= -->
                <canvas id="lineChart" style="height: 370px; width: 100%;"></canvas>
                <!-- ============================= -->
                <!-- ========== GRAFICA ========== -->
                <!-- ============================= -->
                <!--
                <div class="loader" style="text-align: center; height: 250px; width: 250px;" *ngIf="boolLoader"></div>
                -->
                <div class="loader" style="text-align: center; height: 250px; width: 250px;" *ngIf="boolLoader"></div>
                <!-- ======================== -->
                <!-- ======= DATABASE ======= -->
                <!-- ======================== -->
                <!-- style="display:none" -->
                <!--
                    <h3 style="display: block" ></h3>
                -->
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="tablaMaterial" class="tablaDeProductos display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                    <thead>
                        <tr>
                            <th>SKU</th>
                            <th>Descripción</th>
                            <th>Fisico</th>
                            <th>Reservado</th>
                            <th>En espera</th>
                            <th>Obra</th>
                            <th>Resguardo</th>
                            <th>Inservible</th>
                            <th>Mantenimiento</th>
                            <th>Estibas</th>
                            <th>Tránsito</th>
                            <th>Venta</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let material of arrayMaterial">
                            <td>{{ material.producto.codigo }}</td>
                            <td>{{ material.producto.descripcion }}</td>
                            <td>{{ material.productoAlmacen.FISICO }}</td>
                            <td>{{ material.productoAlmacen.RESERVADO }}</td>
                            <td>{{ material.productoAlmacen.ESPERA }}</td>
                            <td>{{ material.productoAlmacen.OBRA }}</td>
                            <td>{{ material.productoAlmacen.RESGUARDO }}</td>
                            <td>{{ material.productoAlmacen.INSERVIBLE }}</td>
                            <td>{{ material.productoAlmacen.MANTENIMIENTO }}</td>
                            <td>{{ material.productoAlmacen.ESTIBAS }}</td>
                            <td>{{ material.productoAlmacen.TRANSITO }}</td>
                            <td>{{ material.productoAlmacen.VENTA }}</td>
                        </tr>
                    </tbody>
                </table>
                <!-- ======================== -->
                <!-- ======= DATABASE ======= -->
                <!-- ======================== -->
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/material-almacen/material-almacen.component.html